export const returnCompleteCnt = (from: string) => {
  switch (from) {
    case "signup":
      return {
        title: "회원가입 완료",
        caption: `에너지엑스의 회원이 되신 것을 환영합니다!\n이제 에너지엑스가 제공하는 모든 서비스를 이용하실 수 있습니다. `,
        label: "프로젝트 의뢰",
        icon: "done_all",
        path: "/project-request",
      };
    case "completed":
      return {
        title: "인증 완료",
        caption: `돌아가셔서 다음 단계를 계속 진행해주세요.`,
        icon: "envelope_opened",
      };
    case "expired":
      return {
        title: "인증 링크 만료",
        caption: `이미 인증 완료됐거나 인증 재요청이 필요합니다.`,
        icon: "helpdesk",
        label: "메인페이지로",
        path: "/",
      };
  }
};
